




























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class DocListItemComponent extends Vue {
  @Prop() readonly items!: any;
  @Prop() readonly emptyText!: string;

  toLocalDate(value) {
    var date = new Date(value);
    return date.toDateString();
  }
}
